module.exports = __webpack_public_path__ + "img/1.bdae2e71.png";